/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import ForcJournalEventBaseComponent from "parog-web/components/forc/abstract/journal-event-based-component";
import JournalEventRetrievalStrategies from "parog-web/components/forc/utils/journal-event-retrieval-strategies";
import type { Job } from "parog-web/models/jobs-declared-journal-event";
import JobsDeclaredJournalEvent from "parog-web/models/jobs-declared-journal-event";

export default class JobsEditionComponent extends ForcJournalEventBaseComponent {
  static fullComponentId = "lifestyle/jobs-edition-form";
  static forcDisplayName = "Socio-professionnel";

  static journalEventClass = JobsDeclaredJournalEvent;
  journalEventProperties = ["occurredAt", "jobs"];
  retrieveJournalEvent =
    JournalEventRetrievalStrategies.sourceOrLastJournalEvent;

  commentaryPrefix = "comment-";
  availableKeys = ["jobCoach", "socialAssistant"];

  retrieveModel() {
    const model = super.retrieveModel();

    // If there is a previous JE comming from our JournalEventRetrievalStrategies
    // the model should have a behaviours property
    if (model.jobs) {
      // Inject the content of the array in our model
      (model.jobs as Job[]).forEach(job => {
        model[job.key] = true;
        model[this.getCommentKey(job.key)] = job.comment;
      });
    }

    return model;
  }

  computePayload() {
    const payload = super.computePayload();
    payload.occurredAt = new Date();

    payload.jobs = this.availableKeys.map(key => {
      if (!this.model[key]) return;

      return {
        key: key,
        comment: this.model[this.getCommentKey(key)]
      };
    });

    return payload;
  }

  getCommentKey(key: string) {
    return this.commentaryPrefix + key;
  }
}
